export var BlendEquationSeparate;
(function (BlendEquationSeparate) {
    BlendEquationSeparate[BlendEquationSeparate["ADD"] = 0] = "ADD";
    BlendEquationSeparate[BlendEquationSeparate["SUBTRACT"] = 1] = "SUBTRACT";
    BlendEquationSeparate[BlendEquationSeparate["REVERSE_SUBTRACT"] = 2] = "REVERSE_SUBTRACT";
    BlendEquationSeparate[BlendEquationSeparate["MIN"] = 3] = "MIN";
    BlendEquationSeparate[BlendEquationSeparate["MAX"] = 4] = "MAX";
})(BlendEquationSeparate || (BlendEquationSeparate = {}));
